<template>
  <div class="page-ranking-list">
    <ym-tabs v-model="tabSelected">
      <ym-tab v-for="(block, index) in blocks"
              :key="index"
              :name="block.type"
              :title="block.name"
      >
        <list :block="block" />
      </ym-tab>
    </ym-tabs>
  </div>
</template>

<script>
  import { Tabs, Tab } from '@ymba/ym-ui';
  import List from '@/pages/Ranking/components/ProductList';
  import { getRankingIndex } from '@/services/ranking';

  export default {
    name: 'PageRankingList',
    metaInfo: {
      title: '排行榜',
    },
    components: {
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      List,
    },
    data() {
      return {
        tabSelected: 0,
        blocks: [],
      };
    },
    methods: {
      generateList(list) {
        return list.map((item, index) => {
          if (index < 3) {
            item.render.mark = {
              type: 'highlight',
              text: `No.${index + 1}`,
              key: 'ranking',
            };
          } else {
            item.render.mark = null;
          }
          return item;
        });
      },
      generateBlocks(data) {
        return data.map((block) => {
          const { list: { length } } = block;
          block.list = this.generateList(block.list);
          block.loading = false;
          block.allLoad = length === 0;
          return block;
        });
      },
      async fetchData() {
        const data = await getRankingIndex();

        this.blocks = this.generateBlocks(data.blocks);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-ranking-list {
    box-sizing: border-box;
    min-height: 100%;
    padding-bottom: @size-extra-small;
    background: @color-white;
  }
</style>
